import React from 'react'
import { Link } from 'react-router-dom'

function SubjectsOffered() {
    return (
        <>
            <div className="innerslide py-3 bg-light border-bottom">
                <ul className="breadcrumb container mb-0">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item">  Academics</li>
                    <li className="breadcrumb-item active">Subjects Offered</li>
                </ul>
            </div>
            <div class="innersec container py-5">
                <h2 class="text-center mb-4 fw-bold">Subject Options – ICSE </h2>
                <div class="card shadow-sm mb-4">
                    <div class="card-header bg-secondary text-white">
                        <h4 class="mb-0">Indian Certificate of Secondary Education (ICSE Std 9 & 10)</h4>
                    </div>
                    <div class="card-body">
                        <h5 class="fw-bold mt-3">Compulsory Subjects</h5>
                        <ul class="list-group mb-3">
                            <li class="list-group-item">English Language</li>
                            <li class="list-group-item">English Literature</li>
                            <li class="list-group-item">Second Language (Hindi or Kannada)</li>
                            <li class="list-group-item">History & Civics and Geography (HCG)</li>
                        </ul>
                        <h5 class="fw-bold mt-4">Combination 1</h5>
                        <ul class="list-group mb-3">
                            <li class="list-group-item">Science (Physics, Chemistry and Biology)</li>
                            <li class="list-group-item">Mathematics</li>
                            <li class="list-group-item">Computer Application / Commercial Application / Robotics and Artificial Intelligence</li>
                        </ul>
                        <h5 class="fw-bold mt-4">Combination 2</h5>
                        <ul class="list-group">
                            <li class="list-group-item">Mathematics</li>
                            <li class="list-group-item">Economics</li>
                            <li class="list-group-item">Commercial Application</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SubjectsOffered